import {IFeatureFlags, IServicePerformanceFlags} from './common'
import servicePerformanceFeatureFlags from './flags'
import {FeatureFlagsHelper} from '@telstra-connect/feature-flags'
import {ApplicationName} from '../activity-tracking'

let helper: FeatureFlagsHelper<typeof ApplicationName>

export const loadFeatureFlags = (
  getFlagsConfigFromState?: () => IServicePerformanceFlags,
): void => {
  helper = new FeatureFlagsHelper(
    ApplicationName,
    getFlagsConfigFromState,
    servicePerformanceFeatureFlags,
  )
}

export const getServicePerformanceFlags = (): IFeatureFlags => helper && helper.getFlags()
